import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { html, LitElement, render } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import * as bootstrap from 'bootstrap';

@customElement('tm-tpc-corrector-temporary-image-modal')
export class TmTPCCorrectorTemporaryImageModal extends LitElement {
    createRenderRoot() {
        return this;
    }

    @property({ type: String })
    imageUrl: string | null = null;

    showModal() {
        const modalElement = document.querySelector('#tm-tpc-corrector-temporary-image-modal');
        if (modalElement) {
            const bootstrapModal = bootstrap.Modal.getOrCreateInstance(modalElement, {
                backdrop: 'static',
                keyboard: false,
            });
            bootstrapModal.show();
        }
    }

    dismissModal() {
        const modalElement = document.querySelector('#tm-tpc-corrector-temporary-image-modal');
        if (modalElement) {
            const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
            bootstrapModal.hide();
        }
    }

    firstUpdated() {
        this.showModal();
    }
    emitConfirm() {
        this.dismissModal();
        this.dispatchEvent(new CustomEvent('confirm'));
    }

    emitCancel() {
        this.dismissModal();
        this.dispatchEvent(new CustomEvent('cancel'));
    }

    render() {
        return html`
            <div
                class="modal fade tm-tpc-corrector-temporary-image-modal"
                data-bs-backdrop="static"
                id="tm-tpc-corrector-temporary-image-modal"
                tabindex="-1"
                aria-hidden="true"
            >
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="tm-tpc-corrector-temporary-image-modal-header">
                            Revise a imagem
                            <button
                                type="button"
                                class="tm-tpc-corrector-limit-error-modal-header-close"
                                aria-label="Close"
                                @click=${this.emitCancel}
                            >
                                <span class="icon icon-012-close"></span>
                            </button>
                        </div>
                        <div class="tm-tpc-corrector-temporary-image-modal-description">
                            Envie só <b>uma pergunta de cada vez</b> e confirme que a imagem é
                            <b>legível e tem boa qualidade</b>.
                        </div>
                        <div class="tm-tpc-corrector-temporary-image-modal-content">
                            <img src=${this.imageUrl || ''} alt="Imagem temporária" />
                        </div>
                        <div class="tm-tpc-corrector-temporary-image-modal-footer">
                            <button
                                class="ds-button ds-button--outline-neutral"
                                @click=${this.emitCancel}
                            >
                                Cancelar
                            </button>
                            <button class="ds-button ds-button--primary" @click=${this.emitConfirm}>
                                Enviar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
